import { styled, TableCell as MuiTableCell } from '@mui/material';

export const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: '0.875rem',
  borderColor: theme.palette.grey['50'],
  padding: '0.625rem 1rem',
  height: '2.1875rem',
  color: theme.palette.primary.main
}));
